module.exports = __webpack_public_path__ + "static/media/timelapse_14.118a9ddb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_14.jpg
// module id = 972
// module chunks = 0